import { colors } from "constants/colors"
import React, { useState, useEffect, useRef } from "react"
import { classNames } from "utils/classNames"
import Step from "./Step"

const Stepper = ({ currentStepNumber, items, recomended }) => {
  const [stepperSteps, setStep] = useState([])
  const stepsStateRef = useRef()
  let newItems = [...items.items, {}];

  useEffect(() => {
    const stepsState = newItems.map((item, index) => {
      const stepObj = {}
      stepObj.completed = false
      stepObj.highlighted = index === 0 ? true : false
      stepObj.selected = index === 0 ? true : false
      stepObj.object = item?.object?.objects?.map((itm) => {
        return (
          {
            id: item?.object?._id,
            title: itm?.title,
            description: `${item?.objectTime} soat`,
          }
        )
      })
      return stepObj
    });


    stepsStateRef.current = stepsState
    const currentSteps = updateStep(currentStepNumber - 1, stepsState)
    setStep(currentSteps);

  }, [recomended])
  useEffect(() => {
    const currentSteps = updateStep(
      currentStepNumber - 1,
      stepsStateRef.current
    )
    setStep(currentSteps)
  }, [currentStepNumber])

  function updateStep(stepNumber, steps) {
    const newSteps = [...steps]
    let stepCounter = 0
    while (stepCounter < newSteps.length) {
      //current step
      if (stepCounter === stepNumber) {
        newSteps[stepCounter] = {
          ...newSteps[stepCounter],
          highlighted: true,
          selected: true,
          completed: true,
        }
        stepCounter++
      }
      // Past step
      else if (stepCounter < stepNumber) {
        newSteps[stepCounter] = {
          ...newSteps[stepCounter],
          highlighted: false,
          selected: true,
          completed: true,
        }
        stepCounter++
      }
      // Future steps
      else {
        newSteps[stepCounter] = {
          ...newSteps[stepCounter],
          highlighted: false,
          selected: true,
          completed: true,
        }
        stepCounter++
      }
    }
    return newSteps
  }

  const stepsDisplay = stepperSteps.map((step, index) => {
    return (
      <div
        key={index}
        className={
          index !== stepperSteps.length - 1
            ? "w-full flex items-center"
            : "flex items-center"
        }
      >
        <div className="relative flex flex-col items-center text-teal-600">
          {/* <div
            className={`absolute -top-8  text-center w-32 text-base font-medium uppercase text-[#323232]`}
          >
            {" "}
            {step.description}
          </div> */}
          <div
            className={`rounded-full transition duration-500 ease-in-out  h-5 w-5 flex items-center justify-center ${step.selected ? "bg-[#3399FF] " : "border-2 border-gray-300"
              }`}
          >
            {!step.highlighted && !step.completed ? (
              <span className="w-2 h-2 rounded-full bg-slate-400" />
            ) : null}
          </div>
        </div>
        <div
          className={classNames(
            step.completed ? "bg-[#EEF1F2]" : "bg-[#EEF1F2]",
            "flex justify-between items-center transition duration-500 ease-in-out h-2 w-full -ml-2 -space-1"
          )}
        >
          {index !== stepperSteps.length - 1 &&
            step.completed &&
            step?.object?.map((item, idx) => {

              return (
                <Step
                  key={item.id}
                  title={item.title}
                  color={colors[idx]}
                  description={item.description}
                  index={index}
                  className={classNames(
                    `h-full w-[101%] cursor-pointer hover:bg-[#3399FF] rounded-r-2xl`
                  )}
                />
              )
            })}
        </div>
      </div>
    )
  })
  return (
    <div className="flex items-center justify-between p-4 mx-4">
      {stepsDisplay}
    </div>
  )
}
export default Stepper
